import { Directive, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { fromEvent, Subject } from 'rxjs';
import { filter, switchMap, takeUntil, throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appMatSelectBottomScroll]'
})
export class MatSelectBottomScrollDirective implements OnDestroy {

  private readonly BOTTOM_SCROLL_OFFSET = 25;
  @Output('appMatSelectBottomScroll') reachedBottom = new EventEmitter<void>();
  onPanelScrollEvent = event => { };
  unsubscribeAll = new Subject<boolean>();

  constructor(private matSelect: MatSelect) {
    this.matSelect.openedChange
      .pipe(
        filter(isOpened => !!isOpened),
        switchMap(isOpened => {
          console.log('MatSelect openedChange triggered'); // Log when openedChange is triggered
          return fromEvent(this.matSelect.panel.nativeElement, 'scroll').pipe(
            throttleTime(50)
          );
        }),
        takeUntil(this.unsubscribeAll)
      )
      .subscribe((event: any) => {
        console.log('scroll');
        // console.log(event, event.target.scrollTop, event.target.scrollHeight);
        if (
          event.target.scrollTop >=
          event.target.scrollHeight -
          event.target.offsetHeight -
          this.BOTTOM_SCROLL_OFFSET
        ) {
          this.reachedBottom.emit();
        }
      });
  }
  ngOnDestroy(): void {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }

}
